import { render, staticRenderFns } from "./dish-card.vue?vue&type=template&id=f80586ce&scoped=true"
import script from "./dish-card.vue?vue&type=script&lang=js"
export * from "./dish-card.vue?vue&type=script&lang=js"
import style0 from "./dish-card.vue?vue&type=style&index=0&id=f80586ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80586ce",
  null
  
)

export default component.exports